import React, { useEffect } from "react";

import Main from '../components/Partner/Main'
import Benefits from "../components/Partner/Benefits";
import HowMuch from "../components/Partner/HowMuch";

function Partner () {
 
    useEffect(() => {
        window.scrollTo(0, 0);
      }, []);
      
    return(
        <div className="relative overflow-hidden mt-[60px]">
            <Main/>
            <Benefits/>
            <HowMuch/>
        </div>
    );
}

export default Partner;